<template>
  <div>
    <div class="table" v-if="groupby === 'employee'">
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Workforce Reports available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of reports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.days"
        width="100%"
        v-loading="loading"
        empty-text="No Workforce Report available."
        class="colored-head"
      >
        <el-table-column :label="getHeader(report)">
          <el-table-column
            sortable
            prop="checkdate"
            label="DATE"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="clockin_readable"
            label="CLOCK IN"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="clockout_readable"
            label="CLOCK OUT"
            width="200"
            ><template slot-scope="scope">
              <span>
                {{ scope.row.clockout_readable }}
              </span>
              <span
                v-if="scope.row.exemption_reason !== 'NA'"
                class="line pointer"
                @click.prevent="$emit('toggleView', scope.row)"
                >View reason</span
              >
            </template></el-table-column
          >
          <el-table-column
            sortable
            prop="shift_name"
            label="SHIFT"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="shift_range"
            label="SHIFT RANGE"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="expected_work_hours"
            label="EXP. WORK HOURS"
            width="250"
          ></el-table-column>
          <el-table-column
            sortable
            prop="hours_worked"
            label="HOURS WORKED"
            width="220"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <div class="table" v-else>
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Workforce Report available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of reports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.employees"
        width="100%"
        v-loading="loading"
        empty-text="No Workforce Report available."
        class="colored-head"
      >
        <el-table-column :label="getDateHeader(report.date)">
          <el-table-column prop="employee_details" label="Name" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="employee_details" label="Pin" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.pin }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            label="Employee Grade"
            width="200"
            v-if="'employee_grade' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_grade || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            label="Employee Type"
            width="200"
            v-if="'employee_type' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_type || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            label="Employee Category"
            width="200"
            v-if="
              'employee_category' in reports[0].employees[0].employee_details
            "
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_category || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            label="Mobile Number"
            width="200"
            v-if="'mobile_number' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.mobile_number || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            label="Email"
            width="200"
            v-if="'email' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.email || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            label="Department"
            width="200"
            v-if="'department' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.department || "NA" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="employee_details"
            label="Branch"
            width="200"
            v-if="'branch' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.branch || "NA" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="clockin_readable"
            label="CLOCK IN"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="clockout_readable"
            label="CLOCK OUT"
            width="200"
            ><template slot-scope="scope">
              <span>
                {{ scope.row.clockout_readable }}
              </span>
              <span
                v-if="scope.row.exemption_reason !== 'NA'"
                class="line pointer"
                @click.prevent="$emit('toggleView', scope.row)"
                >View reason</span
              >
            </template></el-table-column
          >
          <el-table-column
            sortable
            prop="shift_name"
            label="SHIFT"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="shift_range"
            label="SHIFT RANGE"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            prop="expected_work_hours"
            label="EXP. WORK HOURS"
            width="250"
          ></el-table-column>
          <el-table-column
            sortable
            prop="hours_worked"
            label="HOURS WORKED"
            width="220"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reports", "groupby", "loading"],

  methods: {
    getHeader(report) {
      return `Employee Name: ${report.employee_details.name} - Pin: ${
        report.employee_details.pin
      }`;
    },

    getDateHeader(date) {
      return `Workforce Report for: ${date}`;
    },
    toggleView() {
      this.$emit("toggleView");
    },
  },
};
</script>
